<template>
  <div class="room-list-header">
    <span>ROOMS</span>
    <i
      v-if="app.isTeacher()"
      class="bx bx-checkbox-square"
      :class="{ active: app.permissions.rooms }"
      :title="app.permissions.rooms ? 'Disable Room Switching' : 'Enable Room Switching'"
      @click="disableSwitching"
    />
    <i v-if="app.isTeacher()" class="bx bx-x" title="Close Breakout Rooms" @click="closeRooms" />
  </div>
</template>

<script setup lang="ts">
import { getApp } from '../models/App';
import { confirm } from '../utils';

const app = getApp();

const closeRooms = async () => {
  // Make sure it wasn't an accidental click to close breakout rooms.
  const yes = await confirm('Do you really want to close all breakout rooms?', undefined, true);

  if (yes) {
    app.restrictedSend('[breakout]close');
    // Update the event log about the fact that the breakout rooms were closed.
    app.send(`[eventLog]All rooms were closed by ${app.getUser()?.name}.`);
  }
};

const disableSwitching = () => {
  app.setGlobalPermission('rooms', !app.permissions.rooms);
};
</script>

<style scoped>
div.room-list-header {
  display: flex;
  font-size: 14px;
  height: 26px;
  color: white;
  background: var(--color-gray);
  align-items: center;
  padding: 0 6px;
}

div.room-list-header > span {
  flex-grow: 1;
}

div.room-list-header > i {
  cursor: pointer;
  font-size: 20px;
}

div.room-list-header > i.active {
  color: var(--color-accent-icon);
}
</style>
